import React, { FC, ReactElement } from 'react';
import styled from 'styled-components';

import BasicText from '@ui/atoms/BasicText';
import FlexColumn from '@ui/atoms/FlexColumn';
import WYSIWYGContent from '@ui/atoms/WYSIWYGContent';

import Checkbox, { ICheckboxProps } from '@ui/forms/Checkbox';

import theme from '@theme/FolxTheme';

interface IFineprintBoxProps {
	finePrint: string;
	checkbox?: boolean;
	checkboxProps?: ICheckboxProps;
	children?: ReactElement[];
	className?: string;
	isWysiwyg?: boolean;
}

const Box = styled(FlexColumn)`
	background: ${theme.colors.beige};
	border-radius: ${theme.radius.lg};
	gap: ${theme.spacing.sm};
	padding: ${theme.spacing.sm};
`;

const FineprintBox: FC<IFineprintBoxProps> = ({
	children,
	checkbox,
	checkboxProps,
	className,
	finePrint,
	isWysiwyg = false,
}) => {
	return (
		<Box className={className}>
			{children}
			{isWysiwyg ? (
				<WYSIWYGContent textVariant="fineprint" dangerouslySetInnerHTML={{ __html: finePrint }} />
			) : (
				<BasicText variant="fineprint">{finePrint}</BasicText>
			)}
			{checkbox && checkboxProps && <Checkbox {...checkboxProps} />}
		</Box>
	);
};

export default styled(FineprintBox)``;
